export const FUNCTION_REF = [
  // "handleSubmit",
  'setValue',
  'serError',
  'control'
  // "watch",
];

export const FORM_ERROR = 'formError';
